import { Dispensary } from "@/custom-types/Dispensary";

const isDispensaryAcceptingOrders = (dispensary: Dispensary) => {
  const {
    deliveryZoneRangeType,
    deliveryZonePostalCodeWhitelist,
    deliveryRadiusMiles,
    hasReservationsEnabled,
    hasDeliveryEnabled,
  } = dispensary;

  const withinDeliveryRange =
    deliveryZoneRangeType === "postal_code"
      ? !!deliveryZonePostalCodeWhitelist?.length
      : !!deliveryRadiusMiles && deliveryRadiusMiles > 0;

  return hasReservationsEnabled || (hasDeliveryEnabled && withinDeliveryRange);
};

export default isDispensaryAcceptingOrders;
